import React, { useEffect } from 'react';
import {
  Button,
  Stack,
  Typography,
  Link as MUILink,
} from '@mui/material';
import { Traveler } from '@marageti/z4-sdk/lib/people';
import { Link } from 'react-router-dom';

const TravelerCreated = ({
  traveler,
}: {
  traveler: Traveler
}) => {
  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  return (
    <Stack
      spacing={3}
      width="100%"
    >
      <Stack spacing={1}>
        <Typography variant="h2">Account Created</Typography>
        <Typography variant="body1">
          An account for
          {' '}
          {traveler.givenName}
          {' '}
          {traveler.familyName}
          {' '}
          has been created. You can now
          {' '}
          <MUILink
            component={Link}
            to="/trip-requests/create"
            replace
          >
            create a trip request
          </MUILink>
          {' '}
          for this traveler and
          {' '}
          <MUILink component={Link} to={`/travelers/${traveler.id}`}>view their profile</MUILink>
          .
        </Typography>
        <Typography />
      </Stack>
      <Stack
        direction="row"
        spacing={2}
        sx={(theme) => ({
          [theme.breakpoints.down('desktop')]: {
            marginTop: 'auto',
            flexDirection: 'column-reverse',
            '& > :not(:first-of-type)': {
              margin: theme.spacing(0, 0, 2.5, 0),
            },
          },
        })}
      >
        <Button
          variant="contained"
          component={Link}
          to={`/travelers/${traveler.id}`}
        >
          Go to Profile
        </Button>

        <Button
          variant="outlined"
          component={Link}
          to="/trip-requests/create"
          replace
        >
          Create Trip Request
        </Button>
      </Stack>
    </Stack>
  );
};

export default TravelerCreated;
